import { Button, Image, Menu, Skeleton } from "antd";
import { Children, useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import Logo from "../../assets/images/logo-sidebar.svg";
import ManageIcon from "../../assets/images/side_nav/manage-contant.svg";
import WhatsappIcon from "../../assets/images/side_nav/whatsapp-icon.svg";
import QuestionIcon from "../../assets/images/side_nav/list-question.svg";
import MyProfileIcon from "../../assets/images/side_nav/profile-icon.svg";
import SubscriptionIcon from "../../assets/images/side_nav/subscription-icon.svg";
import ContactIcon from "../../assets/images/side_nav/contract-icon.svg";
import ScheduleMessage from "../../assets/images/side_nav/schedule-message.svg";
import TemplateIcon from "../../assets/images/side_nav/template.png";
import ChangePassIcon from "../../assets/images/side_nav/change-pass-icon.svg";
import ChatIcon from "../../assets/images/side_nav/chat-icon.svg";
import LogOutIcon from "../../assets/images/side_nav/log-out-icon.svg";
import UpgradeIcon from "../../assets/images/king-logo-icon.svg";

import { AuthContext } from "../../context/AuthContext";
import DeleteModal from "../DeleteModal";
import { useAppContext } from "../../context/AppContext";
import { Severty, ShowToast } from "../../helper/toast";
import { CheckCircleFilled } from "@ant-design/icons";

export const menuItems = [
  {
    key: "dashboard",
    path: "/dashboard",
    icon: ManageIcon,
    label: "Dashboard ",
  },
  {
    key: "dashboard-management",
    path: "/",
    icon: ManageIcon,
    label: "Manage Content ",
  },
  {
    key: "whatsapp configuration",
    label: "Whatsapp Configuration ",
    icon: WhatsappIcon,
    path: "/whatsapp-configuration-dashboard",
  },

  {
    key: "schedule message",
    label: "Schedule Message ",
    icon: ScheduleMessage,
    path: "/schedule-message",
  },

  {
    key: "contact list",
    label: "Contact ",
    icon: ContactIcon,
    path: "/contact-access",
  },
  {
    key: "template list",
    label: "Template ",
    icon: TemplateIcon,
    path: "/template",
  },
  {
    key: "list of questions",
    label: "List of Questions",
    icon: QuestionIcon,
    path: "/list-of-questions",
  },
  // {
  //   key: "access all chats",
  //   label: "Access All Chats",
  //   icon: ChatIcon,
  //   path: "/chat",
  // },
  {
    key: "my profile",
    label: "My Profile",
    icon: MyProfileIcon,
    path: "/my-profile",
  },

  {
    key: "subscription",
    label: "Subscription",
    icon: SubscriptionIcon,
    path: "/subscription-plan",
  },

  {
    key: "change password",
    label: "Change Password",
    icon: ChangePassIcon,
    path: "/change-password",
  },
];

function Sidenav({ color }) {
  const { userProfile, logout, setUserProfile } = useContext(AuthContext);
  const { country } = useAppContext();

  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [menuLinks, setMenuLinks] = useState([]);
  const [menuMode, setMenuMode] = useState("inline");

  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);

  const showDeleteConfirm = (record) => {
    // logout();
    setIsLogoutModalVisible(true);
  };

  const renderTitle = (item) => {
    return (
      <>
        <Image preview={false} src={item.icon} />
        <span className="label">{item.label}</span>
      </>
    );
  };

  useEffect(() => {
    // setLoading(true);
    if (!userProfile) return;
    if (userProfile.type == "Admin") {
      const items = menuItems;
      setMenuLinks(items);
      setLoading(false);
      return;
    }

    const newArray = menuItems.filter((item) => {
      if (item.isShow) {
        return true;
      } else {
        return userProfile?.role_id?.permission?.includes(item.key);
      }
    });

    const links = newArray.filter((item) => {
      if (item?.children?.length) {
        return true;
      } else if (!item?.children) {
        return true;
      } else {
        return false;
      }
    });

    setMenuLinks(links);
    setLoading(false);
  }, [userProfile, country]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setMenuMode("inline");
      } else {
        setMenuMode("vertical");
      }
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {loading ? (
        [1, 2, 3, 4, 5, 6].map((item) => <Skeleton active key={item} />)
      ) : (
        <>
          <div className="brand-logo">
            <NavLink to="/" className="imgOuter">
              <img className="" src={Logo} alt="" />
            </NavLink>
          </div>
          <Menu inlineCollapsed={false} mode="inline" className="sideNavMain">
            {menuItems.map((item) => {
              if (item.children) {
                return (
                  <>
                    <Menu.SubMenu
                      className="vehicle-icon"
                      key={item.key}
                      title={
                        <>
                          <span className="icon">
                            <Image preview={false} src={item.icon} />
                          </span>
                          <span className="label">{item.label}</span>
                        </>
                      }
                    >
                      {item.children.map((child) => (
                        <Menu.Item key={child.key}>
                          <NavLink to={child.path}>
                            {renderTitle(child)}&nbsp;
                          </NavLink>
                        </Menu.Item>
                      ))}
                    </Menu.SubMenu>
                  </>
                );
              }

              return (
                <Menu.Item key={item.key} disabled={item?.comming_soon}>
                  <NavLink to={item.path}>
                    {renderTitle(item)}&nbsp;
                    {item?.comming_soon ? "(Comming Soon)" : ""}
                  </NavLink>
                </Menu.Item>
              );
            })}

            <Menu.Item onClick={showDeleteConfirm}>
              <NavLink to={"#"}>
                <>
                  <Image preview={false} src={LogOutIcon} />
                  <span className="label">Logout</span>
                </>
              </NavLink>
            </Menu.Item>
          </Menu>
          <div className="Upgrade-plan-box">
            <div className="upgrade-plan-header">
              <CheckCircleFilled />
              <span>Gold</span>
            </div>
            <img src={UpgradeIcon} />
            <h6>Upgrade Plan</h6>
            <p>Get access to all features on tulumbas</p>
            <a href="/subscription-plan">
              <Button className="get-upgrade-plan">Get Pro</Button>
            </a>

          </div>
        </>
      )}
      {isLogoutModalVisible && (
        <DeleteModal
          title={"Logout"}
          subtitle={`Are you sure you want to logout 
      your account?`}
          show={isLogoutModalVisible}
          hide={() => {
            setIsLogoutModalVisible(false);
          }}
          onOk={() => {
            ShowToast("Logout Successfully!", Severty.SUCCESS);
            logout();
            setIsLogoutModalVisible(false);
          }}
        />
      )}
    </>
  );
}

export default Sidenav;
